import { render } from "./ShipTrackZipcode.vue?vue&type=template&id=22c04718&scoped=true"
import script from "./ShipTrackZipcode.vue?vue&type=script&lang=js"
export * from "./ShipTrackZipcode.vue?vue&type=script&lang=js"

import "./ShipTrackZipcode.vue?vue&type=style&index=0&id=22c04718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c04718"]])

export default __exports__